import React, { useState } from 'react';
import CompanyInput from './components/CompanyInput';
import ChatInterface from './components/ChatInterface';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('input'); // 'input' or 'chat'
  const [companyTicker, setCompanyTicker] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [dateRange, setDateRange] = useState(null);
  
  const handleCompanySelected = (ticker, name, selectedDateRange = null) => {
    setCompanyTicker(ticker);
    setCompanyName(name);
    setDateRange(selectedDateRange);
    setCurrentPage('chat');
  };

  const handleBackToInput = () => {
    setCurrentPage('input');
    setCompanyTicker('');
    setCompanyName('');
    setDateRange(null);
  };

  return (
    <div className="app">
      {currentPage === 'input' ? (
        <CompanyInput onCompanySelected={handleCompanySelected} />
      ) : (
        <ChatInterface 
          companyTicker={companyTicker}
          companyName={companyName}
          dateRange={dateRange}
          onBackToInput={handleBackToInput}
        />
      )}
    </div>
  );
}

export default App;
